import axios from './http'
var qs = require('qs');

//报告列表
export function httpMyList(page, limit, search) {
    let data = {
        page, limit, search
    }
    return axios({
        url: '/adminapi/scheduling/scheduling/my-list',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}